import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function ColumnSettings({ allColumns, visibleColumns, onVisibleColumnsChange, onClose }) {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');

  const filteredColumns = allColumns.filter(col =>
    col.toLowerCase().includes(search.toLowerCase())
  );

  const toggleColumn = (col) => {
    if (visibleColumns.includes(col)) {
      if (visibleColumns.length === 1) return; // at least one column must be visible
      onVisibleColumnsChange(visibleColumns.filter(c => c !== col));
    } else {
      onVisibleColumnsChange([...visibleColumns, col]);
    }
  };

  const selectAll = () => onVisibleColumnsChange([...allColumns]);
  const deselectAll = () => onVisibleColumnsChange([allColumns[0]]); // keep at least one

  return (
    <div className="settings-overlay" onClick={onClose}>
      <div className="settings-panel" onClick={e => e.stopPropagation()}>
        <div className="settings-header">
          <h3>{t('columnSettings')}</h3>
          <button className="settings-close" onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        
        <div className="settings-search">
          <input
            type="text"
            placeholder={t('searchColumn')}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="settings-actions">
          <button className="btn-sm-action" onClick={selectAll}>{t('selectAll')}</button>
          <button className="btn-sm-action" onClick={deselectAll}>{t('deselectAll')}</button>
          <span className="column-count">{t('columnsCount', { visible: visibleColumns.length, total: allColumns.length })}</span>
        </div>

        <div className="settings-list">
          {filteredColumns.map(col => (
            <label key={col} className="column-item">
              <input
                type="checkbox"
                checked={visibleColumns.includes(col)}
                onChange={() => toggleColumn(col)}
              />
              <span className="column-name">{col}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}
